/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Name_LabelInputs */

const th_team_name_label = /** @type {(inputs: Team_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ชื่อ`)
};

const en_team_name_label = /** @type {(inputs: Team_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const ja_team_name_label = /** @type {(inputs: Team_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名称`)
};

const zh_team_name_label = /** @type {(inputs: Team_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名称`)
};

const es_team_name_label = /** @type {(inputs: Team_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre`)
};

const pt_team_name_label = /** @type {(inputs: Team_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome`)
};

const id_team_name_label = /** @type {(inputs: Team_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama`)
};

const fr_team_name_label = /** @type {(inputs: Team_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom`)
};

const tl_team_name_label = /** @type {(inputs: Team_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pangalan`)
};

const vi_team_name_label = /** @type {(inputs: Team_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên`)
};

const ko_team_name_label = /** @type {(inputs: Team_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이름`)
};

const de_team_name_label = /** @type {(inputs: Team_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const ru_team_name_label = /** @type {(inputs: Team_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Название`)
};

const tr_team_name_label = /** @type {(inputs: Team_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ad`)
};

const it_team_name_label = /** @type {(inputs: Team_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome`)
};

const pl_team_name_label = /** @type {(inputs: Team_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nazwa`)
};

const uk_team_name_label = /** @type {(inputs: Team_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Назва`)
};

const hi_team_name_label = /** @type {(inputs: Team_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नाम`)
};

const ar_team_name_label = /** @type {(inputs: Team_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الاسم`)
};

const ms_team_name_label = /** @type {(inputs: Team_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama`)
};

const bn_team_name_label = /** @type {(inputs: Team_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নাম`)
};

const zh_tw2_team_name_label = /** @type {(inputs: Team_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名稱`)
};

const zh_hk2_team_name_label = /** @type {(inputs: Team_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名稱`)
};

const ur_team_name_label = /** @type {(inputs: Team_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نام`)
};

const fa_team_name_label = /** @type {(inputs: Team_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نام`)
};

const sw_team_name_label = /** @type {(inputs: Team_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jina`)
};

const nl_team_name_label = /** @type {(inputs: Team_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naam`)
};

/**
* | output |
* | --- |
* | "Name" |
*
* @param {Team_Name_LabelInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const team_name_label = /** @type {((inputs?: Team_Name_LabelInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Name_LabelInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_team_name_label(inputs)
	if (locale === "ja") return ja_team_name_label(inputs)
	if (locale === "zh") return zh_team_name_label(inputs)
	if (locale === "es") return es_team_name_label(inputs)
	if (locale === "pt") return pt_team_name_label(inputs)
	if (locale === "id") return id_team_name_label(inputs)
	if (locale === "fr") return fr_team_name_label(inputs)
	if (locale === "tl") return tl_team_name_label(inputs)
	if (locale === "vi") return vi_team_name_label(inputs)
	if (locale === "ko") return ko_team_name_label(inputs)
	if (locale === "de") return de_team_name_label(inputs)
	if (locale === "ru") return ru_team_name_label(inputs)
	if (locale === "tr") return tr_team_name_label(inputs)
	if (locale === "it") return it_team_name_label(inputs)
	if (locale === "pl") return pl_team_name_label(inputs)
	if (locale === "uk") return uk_team_name_label(inputs)
	if (locale === "hi") return hi_team_name_label(inputs)
	if (locale === "ar") return ar_team_name_label(inputs)
	if (locale === "ms") return ms_team_name_label(inputs)
	if (locale === "bn") return bn_team_name_label(inputs)
	if (locale === "zh-TW") return zh_tw2_team_name_label(inputs)
	if (locale === "zh-HK") return zh_hk2_team_name_label(inputs)
	if (locale === "ur") return ur_team_name_label(inputs)
	if (locale === "fa") return fa_team_name_label(inputs)
	if (locale === "sw") return sw_team_name_label(inputs)
	if (locale === "nl") return nl_team_name_label(inputs)
	return en_team_name_label(inputs)
});